import * as React from "react";
import { forwardRef } from "react";
const SvgWiserfunding = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9.29 11.73V8H7.945l-3.644 3.73H3v3.775h1.301l3.644-3.774H9.29Zm6.377 0V8h-1.345l-3.644 3.73H9.377v3.775h1.301l3.644-3.774h1.345Zm6.333 0V8h-1.345l-3.644 3.73H15.71v3.775h1.301l3.644-3.774H22Z" }));
const ForwardRef = forwardRef(SvgWiserfunding);
export default ForwardRef;
